module.exports = __webpack_public_path__ + "img/icons_solid.e8f8c0eb.svg";